import {addClass, findAll, find, onReady, wrap, makeRandomString} from "../../../../modules/vegas/js/util";

function ready() {
	[...findAll('.page-default')].map((page) => {
		[...findAll('img', page)].map((img) => {
			addClass(img, 'img-fluid')
		});

		[...findAll('a[href=""][data-fancybox] img', page)].map((img) => {
			let a = img.closest('a');
			a.setAttribute('href', img.getAttribute('src'));
		});

		[...findAll('table', page)].map((table) => {
			addClass(table, ['table', 'table-hover', 'table-bordered'])
			wrap(table, 'table-responsive');
		})
	});

	let sSearch = document.getElementById('sidebar-search');
	if(sSearch) {
		sSearch.addEventListener('vg.sidebar.shown', function () {
			let input = sSearch.querySelector('input[name="search"]');
			if (input) {
				input.focus();
			}
		})
	}

	[...findAll('ul.todo-list')].forEach(function (el) {
		let text = [...findAll('li', el)].map(item => {
			let content = item.innerHTML;

			if (extractAnchorTag(content)) {
				return extractAnchorTag(content);
			} else {
				return item.innerText;
			}
		});

		function extractAnchorTag(html) {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const anchor = doc.querySelector('a');
			return anchor ? anchor.outerHTML : '';
		}

		let list = document.createElement('ul');
		list.classList.add('todo-list');

		text.forEach((elm) => {
			let id = 'td-' + makeRandomString();

			let li = document.createElement('li');
			let check = document.createElement('div');
			check.classList.add('form-check');

			let input = document.createElement('input');
			input.setAttribute('type', 'checkbox');
			input.setAttribute('disabled', 'disabled');
			input.classList.add('form-check-input');
			input.checked = true;
			input.id = id;

			let label = document.createElement('label');
			label.classList.add('form-check-label');
			label.setAttribute('for', id);
			label.innerHTML = elm.trim();

			check.append(input);
			check.append(label);
			li.append(check);
			list.append(li);
		});

		el.after(list);
		el.remove();
	});
}

onReady(ready);
typeof onTurboRender !== 'undefined' && onTurboRender(ready);

